import type { JSX } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useQuery } from "urql";
import FeedbackTaskDescription from "../../shared/components/FeedbackTaskDescription";
import Loader from "../../shared/components/Loader";
import ShowError from "../components/ShowError";
import Feedback from "./Feedback";
import { query } from "./queries";
import RequestAnswer from "./RequestAnswer";

function ProvideFeedback(): JSX.Element {
    const location = useLocation();
    // Extract id from pathname: /provide-feedback/123/... -> 123
    const id = location.pathname.split("/")[2];
    const [result] = useQuery({
        query,
        variables: { id },
    });

    if (result.fetching) {
        return <Loader />;
    }
    if (result.error) {
        return <ShowError />;
    }

    const feedbackTask = result.data.feedbackTask;
    if (!feedbackTask) {
        return <Navigate to="/landing" replace={true} />;
    }

    const submittedFeedbackTask = feedbackTask.submittedFeedbackTask;
    const task = submittedFeedbackTask || feedbackTask;
    const submittedTask = submittedFeedbackTask?.selectedSubmittedTaskVariant.submittedTask;
    const pathname = feedbackTask.learningPathItem.learningPath.pathname;
    const instructions = submittedFeedbackTask ? submittedFeedbackTask.instructions : undefined;
    return (
        <>
            <FeedbackTaskDescription
                shortTitle={task.shortTitle}
                title={task.title}
                instructions={instructions}
                icon={task.icon}
                miles={task.miles}
                deadline={feedbackTask.deadline}
                finishDatetime={
                    submittedFeedbackTask?.status === "finished" ? submittedFeedbackTask.finishDatetime : null
                }
            />
            {submittedFeedbackTask === null && <RequestAnswer id={id} pathname={pathname} />}
            {!!submittedTask && (
                <Feedback
                    submittedTask={submittedTask}
                    pathname={pathname}
                    submittedFeedbackTaskId={submittedFeedbackTask?.id}
                />
            )}
        </>
    );
}

export default ProvideFeedback;
